/* tslint:disable */
import {
  PropertyBills,
  UserProfile
} from '../index';

declare var Object: any;
export interface PropertyBillsEditMemoInterface {
  "memo": string;
  "property_bills_id": number;
  "archive": any;
  "user_id": number;
  "id"?: number;
  propertyBills?: PropertyBills;
  userProfile?: UserProfile;
}

export class PropertyBillsEditMemo implements PropertyBillsEditMemoInterface {
  "memo": string;
  "property_bills_id": number;
  "archive": any;
  "user_id": number;
  "id": number;
  propertyBills: PropertyBills;
  userProfile: UserProfile;
  constructor(data?: PropertyBillsEditMemoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyBillsEditMemo`.
   */
  public static getModelName() {
    return "PropertyBillsEditMemo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyBillsEditMemo for dynamic purposes.
  **/
  public static factory(data: PropertyBillsEditMemoInterface): PropertyBillsEditMemo{
    return new PropertyBillsEditMemo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyBillsEditMemo',
      plural: 'PropertyBillsEditMemos',
      path: 'PropertyBillsEditMemos',
      idName: 'id',
      properties: {
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "property_bills_id": {
          name: 'property_bills_id',
          type: 'number'
        },
        "archive": {
          name: 'archive',
          type: 'any'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        propertyBills: {
          name: 'propertyBills',
          type: 'PropertyBills',
          model: 'PropertyBills',
          relationType: 'belongsTo',
                  keyFrom: 'property_bills_id',
          keyTo: 'id'
        },
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'user_id',
          keyTo: 'id'
        },
      }
    }
  }
}
